module.exports = __webpack_public_path__ + "media/assets/goldenFooter-18e06f475868386f89e18f77da3a2720.png";